/**
 * XMLHttpRequest transport strategy
 * Priority: Low (fallback for older browsers)
 */

import type { TransportStrategy, TransportPayload } from './TransportStrategy.js';

export class XHRTransport implements TransportStrategy {
  name = 'xhr';
  priority = 10;

  isAvailable(): boolean {
    return typeof XMLHttpRequest !== 'undefined';
  }

  async send(payload: TransportPayload): Promise<void> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      
      xhr.open('POST', payload.endpoint, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      
      if (payload.headers) {
        Object.entries(payload.headers).forEach(([key, value]) => {
          xhr.setRequestHeader(key, value);
        });
      }

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve();
        } else {
          reject(new Error(`HTTP ${xhr.status}: ${xhr.statusText}`));
        }
      };

      xhr.onerror = () => {
        reject(new Error('Network error'));
      };

      xhr.send(JSON.stringify(payload.data));
    });
  }

  sendSync(payload: TransportPayload): boolean {
    try {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', payload.endpoint, false); // Synchronous
      xhr.setRequestHeader('Content-Type', 'application/json');
      
      if (payload.headers) {
        Object.entries(payload.headers).forEach(([key, value]) => {
          xhr.setRequestHeader(key, value);
        });
      }

      xhr.send(JSON.stringify(payload.data));
      return xhr.status >= 200 && xhr.status < 300;
    } catch (error) {
      return false;
    }
  }
}

